/** Parse holiday/event row date from ISO or DD-MM-YYYY label. */
export function parseDashboardRowDate(row) {
  const raw = row?.date ?? row?.holidayDate ?? row?.eventDate;
  if (raw != null && String(raw).trim() !== "") {
    const s = String(raw).trim();
    if (/^\d{4}-\d{2}-\d{2}/.test(s)) {
      const d = new Date(s.slice(0, 10));
      return Number.isNaN(d.getTime()) ? null : d;
    }
    const d = new Date(s);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const dl = row?.dateLabel ?? row?.date_label;
  if (dl && /^\d{2}-\d{2}-\d{4}$/.test(String(dl).trim())) {
    const [day, mon, year] = String(dl)
      .trim()
      .split("-")
      .map((n) => Number(n));
    const d = new Date(year, mon - 1, day);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  return null;
}

function parseJoineeJoinDate(row) {
  const raw =
    row?.doj ??
    row?.joinedAt ??
    row?.joinDate ??
    row?.hireDate ??
    row?.joined_at;
  if (raw == null || raw === "") return null;
  const s = String(raw).trim();
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) {
    const d = new Date(s.slice(0, 10));
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** New joiners whose join date falls in the current calendar month. */
export function filterNewJoineesThisMonth(rows) {
  if (!Array.isArray(rows)) return [];
  const now = new Date();
  const y = now.getFullYear();
  const m = now.getMonth();
  return rows.filter((row) => {
    const d = parseJoineeJoinDate(row);
    if (!d) return false;
    return d.getFullYear() === y && d.getMonth() === m;
  });
}

/** Holidays from the first day of this month through the last day of next month. */
export function filterHolidaysThisAndNextMonth(rows) {
  if (!Array.isArray(rows)) return [];
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), 1);
  const end = new Date(now.getFullYear(), now.getMonth() + 2, 0, 23, 59, 59, 999);
  return rows.filter((row) => {
    const d = parseDashboardRowDate(row);
    if (!d) return false;
    return d >= start && d <= end;
  });
}

export function splitHolidaysByRegion(rows) {
  const inList = [];
  const usList = [];
  (rows || []).forEach((h) => {
    const r = String(h?.locationRegion ?? h?.location_region ?? "")
      .trim()
      .toUpperCase();
    if (r === "US") usList.push(h);
    else if (r === "IN") inList.push(h);
  });
  return { inList, usList };
}
